// スマホアプリを開くリンクURL
export const androidAppUrl =
  'intent://gaishishukatsu#Intent;scheme=gsskt;action=boot;package=com.gaishishukatsu.Gaishishukatsu;end';
export const iosAppUrl =
  'itmss://itunes.apple.com/us/app/wai-zi-jiu-huodottokomu/id517232947?mt=8&at=&ct=&ign-mpt=uo%3D6';

// スマホアプリのWeb版紹介ページへ導くリンク
export const androidAppStoreUrl =
  'https://play.google.com/store/apps/details?id=com.gaishishukatsu.Gaishishukatsu&hl=ja';
export const iosAppStoreUrl =
  'https://itunes.apple.com/jp/app/%E3%83%88%E3%83%83%E3%83%97%E4%BC%81%E6%A5%AD%E3%81%B8%E5%86%85%E5%AE%9A%E3%82%92%E3%82%81%E3%81%96%E3%81%99%E5%B0%B1%E8%81%B7%E6%B4%BB%E5%8B%95%E3%82%A2%E3%83%97%E3%83%AA-%E5%A4%96%E8%B3%87%E5%B0%B1%E6%B4%BB%E3%83%89%E3%83%83%E3%83%88%E3%82%B3%E3%83%A0/id517232947?mt=8';
